export default __webpack_public_path__ + "locales/it/Notifications.json?hash=b59d78d63e52029679ac82652ab7dba3";